import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './_template/login/login.component';
import { SharedModule } from './_modules/shared/shared.module';
import { LoadingComponent } from './_template/loading/loading.component';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from '../environments/environment';
import { HttpClientModule } from '@angular/common/http';
import { TokenGetter } from './helper';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoadingComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        allowedDomains: environment.allowedDomains,
        tokenGetter: TokenGetter,
      }
    })

  ],
  providers: [],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
